import { getProducts } from './baseHelper';
import {
  BaseZendeskState,
  BaseZendeskAction,
  BaseZendeskFormAction,
  BaseZendeskFormState,
  BaseZendeskOrderLessFormState,
  ZendeskOrderLessAction
} from './types';

export const baseZendeskFormReducer = <T extends BaseZendeskState>(
  state: T,
  action: BaseZendeskAction
): T => {
  switch (action.type) {
    case 'subject':
    case 'subjectError':
    case 'reason':
    case 'reasonError':
    case 'question':
    case 'questionError':
      return { ...state, [action.type]: action.value };
    default:
      return state;
  }
};

export const zendeskOrderLessFormReducer = <T extends BaseZendeskOrderLessFormState>(
  state: T,
  action: ZendeskOrderLessAction
): T => {
  switch (action.type) {
    case 'orderId':
    case 'productNumber':
      return { ...state, [action.type]: action.value };
    default:
      return state;
  }
};

export const addProductsReducer = <T extends BaseZendeskFormState>(
  state: T,
  action: BaseZendeskFormAction
): T => {
  switch (action.type) {
    case 'productChanged':
      return { ...state, products: getProducts(action.value, state.products) };
    case 'productsError':
      return { ...state, productsError: action.value };
    default:
      return state;
  }
};
